import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";
import Articles from "@/pages/Articles";
import JournalsIndex from "@/pages/JournalsIndex";
import CategoryPage from "@/pages/CategoryPage";
import JournalDetail from "@/pages/JournalDetail";
import PaperDetail from "@/pages/PaperDetail";
import SearchResults from "@/pages/SearchResults";
import SpecialIssuesPage from "@/pages/SpecialIssuesPage";
import ForAuthors from "@/pages/ForAuthors";
import ForReviewers from "@/pages/ForReviewers";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import PolicyPage from "@/pages/PolicyPage";
import MemberProfile from "@/pages/MemberProfile";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Submit from "@/pages/Submit";
import PaymentPage from "@/pages/PaymentPage";
import Dashboard from "@/pages/Dashboard";
import AuthCallback from "@/pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/articles" element={<Articles />} />
        <Route path="/journals" element={<JournalsIndex />} />
        <Route path="/special-issues" element={<SpecialIssuesPage />} />
        <Route path="/for-authors" element={<ForAuthors />} />
        <Route path="/for-reviewers" element={<ForReviewers />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/peer-review" element={<PolicyPage slug="peer-review" eyebrow="Editorial Policy" breadcrumb="Peer Review Process" />} />
        <Route path="/open-access" element={<PolicyPage slug="open-access" eyebrow="Policy" breadcrumb="Open Access Policy" />} />
        <Route path="/publication-ethics" element={<PolicyPage slug="publication-ethics" eyebrow="Policy" breadcrumb="Publication Ethics" />} />
        <Route path="/category/:slug" element={<CategoryPage />} />
        <Route path="/journal/:slug" element={<JournalDetail />} />
        <Route path="/journal/:slug/member/:key" element={<MemberProfile />} />
        <Route path="/paper/:id" element={<PaperDetail />} />
        <Route path="/search" element={<SearchResults />} />
        <Route path="/submit" element={<Submit />} />
        <Route path="/pay/:paperId" element={<PaymentPage />} />
      </Route>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
